import React from 'react';
import PropTypes from 'prop-types';

import { RichContent } from '../elements/index';
import FormButton from '../elements/FormButton';
import FormInput from '../elements/FormInput';

import { validateAcceptableSpecialCharacters, validateEmailAddress, validateName, validateURL } from '../../../../helpers/genericHelpers';
import {isValidPhoneNumber} from 'react-phone-number-input';

class ContactFormComponent extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			errors: [],
			type: '',
			values: {
				destination: this.props.contactForm.destinationEmailAddress
			},
			success: null
		}
	}
	//Needs refactoring + abstracting
	handleClick = (e) => {
		fetch('https://blog.intouchnetworks.com/wp-json/contact-form/v1', {
			method: 'POST',
			body: JSON.stringify(this.state.values),
			headers: {
				'Content-Type': 'application/json'
			}
		}).then(res => res.json())
			.then(response => {
		  		this.setState({
					errors: [],
					type: '',
					values: {  destination: this.props.contactForm.destinationEmailAddress},
					success: true
				});
				document.getElementById("form__inputs").reset();
				setTimeout(() => {
					this.setState({success: null})
				}, 10000);
		})
	};

	handleChange = (event, type, field) => {
		this.setState({
			values: {
				...this.state.values,
				[`${type}${field}`]: event.target.value,
				source: this.props.contactForm.source
			}
		});
		return this.validate(event.target.value, type);
	};

	validate = (value, type) => {
		let validation = {
			'email': !!validateEmailAddress(value),
			'tel': !!isValidPhoneNumber(value),
			'name': !!validateName(value),
			'text': !!validateAcceptableSpecialCharacters(value),
			'url': !!validateURL(value)
		};

		if(value === "" || validation[type]) {
			this.addError(type);
		} else if (!validation[type] && value !== "") {
			this.removeError(type);
		}

		return value !== "" || null ? validation[type] : true;
	};

	addError = (type) => {
		if(!this.state.errors.includes(type)) {
			this.setState({errors: [...this.state.errors, type]})
		}

	};

	removeError = (type) => {
		if(this.state.errors.includes(type)) {
			let newArray = this.state.errors.filter(i => i !== type);
			this.setState({errors: newArray })
		}
	};

	render() {
		const {contactForm} = this.props;

		const style = {
			border: `2px solid ${contactForm.button.color}`,
			backgroundColor: `${contactForm.backgroundColor}`
		};
	
		return(
			<section className="kiwi-contact-form">
				<div className="container">
					<div className="row">
						<div className="col-xs-12 col-md-offset-2 col-md-8">
							<div className="row">
								<div className="col-xs-12">
									<div className="contact-form form" style={style}>
										<div className="form__title">
											<RichContent dangerous={contactForm.description}/>
										</div>
										<form className="form__inputs" id="form__inputs">
											{ contactForm.fields.map((field, i) => {
												return <FormInput placeholder={field.placeholder}
																  label={field.label}
																  type={field.type}
																  handleChange={this.handleChange}
																  key={i}
																  field={i}
																  inputStyle={contactForm.button.color}
												/>
											})}
										</form>
										<div className="form__button">
											<FormButton label={this.state.success ? "Successfully sent" : contactForm.button.label}
														hasErrors={this.state.errors}
														handleClick={this.handleClick}
														content={this.state.values}
														numberOfFields={contactForm.fields.length}
														primaryColor={contactForm.button.primaryColor}
														secondaryColor={contactForm.button.secondaryColor}
														textColor={contactForm.button.textColor}
														success={this.state.success}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>	
				</div>
			</section>
		);
	}
}

export default ContactFormComponent;

ContactFormComponent.propTypes = {
	contactForm: PropTypes.object,
};


// WEBPACK FOOTER //
// src/client/components/common/CMS/components/ContactFormComponent.js